import React, { useRef } from 'react';
import ShuttleInformation from '../shuttle-information/ShuttleInformation';
import AccessHours from 'common/spot-details/access-hours';
import FacilityLocation from '../facility-location/FacilityLocation';
import SafetyAmenities from '../safety-amenities/SafetyAmenities';
import ThingsYouShouldKnow from 'common/spot-details/things-you-should-know';
import HowToRedeemArrivalDeparture from '../arrival-departure-redemption-instructions/HowToRedeemArrivalDeparture';
import FAQPanels from 'common/spot-details/faq';
import TrustSealValueProps from 'common/spot-details/trust-seal-and-value-props/TrustSealValueProps';
import SpotDetailsHeader from '../header/SpotDetailsHeader';
import { Box, Heading } from '@spothero/ui';
import { Reviews } from 'common/spot-details/reviews';
import { ScrollToReviewsContext, scrollToReviewsElement, } from 'common/spot-details/context/ScrollToReviewsContext';
export const AirportDetails = ({ shuttle, title, iataCode, facility, selectedRate, linearMeters, amenities, hasInOutAmenity, facilityRestrictions, cancellationAllowed, airportPercentLowerPrice, showBenefitMessage, }) => {
    const spotDetailsContainerRef = useRef(null);
    const reviewsRef = useRef(null);
    const stickyHeaderRef = useRef(null);
    const scrollToReviews = () => {
        scrollToReviewsElement(reviewsRef, spotDetailsContainerRef, stickyHeaderRef);
    };
    const scrollContextValue = {
        scrollToReviews,
    };
    return (<ScrollToReviewsContext.Provider value={scrollContextValue}>
            <Box ref={spotDetailsContainerRef}>
                <SpotDetailsHeader facility={facility} percentLowerPrice={airportPercentLowerPrice} linearMeters={linearMeters} walkingMeters={null} showBenefitMessage={showBenefitMessage}/>
                <ShuttleInformation shuttle={shuttle} facilityTitle={title} iataCode={iataCode}/>
                <AccessHours facility={facility} rate={selectedRate} sectionTitle="Facility Access Hours"/>
                <FacilityLocation facility={facility} linearMeters={linearMeters} walkingMeters={null}/>
                <SafetyAmenities amenities={amenities}/>
                <ThingsYouShouldKnow hasInOutAmenity={hasInOutAmenity} restrictions={facilityRestrictions}/>
                <HowToRedeemArrivalDeparture facility={facility}/>
                <Box ref={reviewsRef} marginX={6} marginBottom={9} borderTop="1px solid" borderColor="gray.100">
                    <Heading as="h4" fontWeight="semibold" marginY={6} fontSize="md">
                        Reviews
                    </Heading>
                    <Reviews ratingInfo={facility.rating_info} facilityId={facility.parking_spot_id} facilityName={facility.title}/>
                </Box>
                <FAQPanels cancellationAllowed={cancellationAllowed}/>
                <TrustSealValueProps />
            </Box>
        </ScrollToReviewsContext.Provider>);
};
export default AirportDetails;
